import { gql } from '@apollo/client'

// Adapted from src/core/App/Components/RecentActivity/Queries/ResourceQuery.js
export const RESOURCE_FOR_FREQUENTLY_USED_CONTENT_QUERY = gql`
query ResourceForFrequentlyUsedContentById($id: String!){
    nodeById(id: $id) {
        ... on NodeResource {
            uuid
            fieldResourceTags {
                entity {
                    entityLabel
                }
            }
            entityChanged
            entityCreated
            nid
            title
            entityId
            entityLabel
            entityType
            fieldResourceDescription
            fieldResourceFromDate
            fieldResourceReleaseDate
            isLikedByCurrentUser
            fieldResourceOfflinePeriod {
                targetId
            }
            fieldResourceFilesByFormat {
                entity {
                    ... on Media {
                        uuid
                        entityChanged
                        entityCreated
                        name
                        mid
                        entityLabel
                        entityType
                        entityBundle
                        entityId
                        uuid
                        bundle {
                            targetId
                        }
                    }

                    ... on MediaMediaFile {
                        fieldMediaFileLanguage {
                            value
                        }

                        fieldMediaFile {
                            entity {
                                ... on File {
                                    uuid
                                    entityChanged
                                    entityCreated
                                    entityId
                                    url
                                    filesize
                                    filemime
                                    filename
                                }
                            }
                        }
                    }
                    ... on MediaSapFile {
                        uuid
                        entityChanged
                        entityId
                        fieldSapFromDate
                        fieldSapReleaseDate
                        fieldSapFileLanguage {
                            value
                        }
                        fieldSapFileFileSize
                        fieldSapFileFileName
                        fieldSapFileDocumentVersion
                        fieldSapFileMime
                        fieldSapFileFileExtension {
                            entity {
                                ... on TaxonomyTermFileExtension {
                                    fieldFileExtensionValue
                                }
                            }
                        }
                    }
                    ... on MediaMasterControl {
                       uuid
                       entityChanged
                       entityId
                       fieldMasterControlId
                       fieldMasterControlCategory
                       fieldMasterControlDescription
                       fieldMasterControlTitle
                       fieldMasterControlRevision
                       fieldMasterControlMime
                       fieldMasterControlSize
                       fieldMasterControlExtension {
                        entity {
                          ... on TaxonomyTermFileExtension {
                            fieldFileExtensionValue
                          }
                        }
                       }
                    }
                    ... on MediaMasterControlAttachment {
                       uuid
                       entityChanged
                       entityId
                       fieldMcAttachmentId
                       fieldMcAttachmentName
                       fieldMcAttachmentDescription
                       fieldMcAttachmentMime
                       fieldMcAttachmentSize
                       fieldMcAttachmentExtension {
                        entity {
                          ... on TaxonomyTermFileExtension {
                            fieldFileExtensionValue
                          }
                        }
                       }
                    }
                    ... on MediaBokeccVideo {
                        fieldBokeccIframe
                    }
                    ... on MediaExternalLink {
                        fieldExternalLinkLink {
                            url {
                                path
                            }
                        }
                    }
                }
            }
        }
    }
}
`
;
